/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Property_Assigned_ToInputs */



/**
* | output |
* | --- |
* | "Assigned To" |
*
* @param {Explorer_Info_Property_Assigned_ToInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_property_assigned_to = /** @type {((inputs?: Explorer_Info_Property_Assigned_ToInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Property_Assigned_ToInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Assigne a")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zugewiesen an")
	if (locale === "it") return /** @type {LocalizedString} */ ("Assegnato a")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Назначен в")
	if (locale === "es") return /** @type {LocalizedString} */ ("Asignado a")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("分配给")
	if (locale === "ja") return /** @type {LocalizedString} */ ("割り当て先")
	if (locale === "hi") return /** @type {LocalizedString} */ ("को सौंपना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Designado para")
	return /** @type {LocalizedString} */ ("Assigned To")
});